<template>
    <section>
        <!--
        <v-container class="nav">
            <v-card-title>
                <v-avatar class="teal mr-2 elevation-5">
                    <v-icon class="white--text">
                        {{ mdiAlertCircle }}
                    </v-icon>
                </v-avatar>

                <h2>Page Not Found</h2>
            </v-card-title>
        </v-container>
        -->
        <div style="width:100%">
            <div class="d-flex justify-space-around align-center">
                <v-card class="elevation-12 not-found-wrapper" dark shaped>
                    <div class="content-wrapper d-flex justify-space-around align-center flex-column">
                        <div class="not-found-content d-flex justify-space-around align-center flex-column">
                            <div class="header">
                                <div class="whiteCross">
                                    <img src="../assets/white-cross.svg" alt="">
                                </div>
                                <h2 class="font-weight-black">
                                    ERROR 404 PAGE NOT FOUND
                                </h2>
                                <h4 class="my-5 red--text">
                                    You will be redirected in {{ timer }}s.
                                </h4>
                                <div class="my-3 text-center">
                                    If you are not redirected automatically, <span @click="toHome">click here</span>.
                                </div>
                            </div>
                        </div>
                    </div>
                </v-card>
            </div>
        </div>
    </section>
</template>
<script>
import { mask } from 'vue-the-mask'
import { mdiAlertCircle } from '@mdi/js'
export default {
    directives: {
        mask
    },
    data: () => ({
        mdiAlertCircle,
        timer: 5,
        intervalId: null
    }),
    created() {
        const interval = setInterval(() => {
            if (this.timer > 0) {
                this.timer--
            }

            if (this.timer === 0) {
                window.location.href = '/'
                clearInterval(interval)
            }
        }, 1000)
    },
    beforeDestroy() {
        clearInterval(this.intervalId)
    },
    methods: {
        toHome() {
            window.location.replace('/')
        }
    }
}
</script>
<style scoped>
section{
    display: flex;
    justify-content: space-around;
    align-items: center;
    height: 100%;
    background-image: url("../assets/loginBG.webp");
    background-position: center;
    background-size: cover;
}

.not-found-wrapper {
    height: 600px;
    display: flex;
    justify-content: space-around;
    align-items: center;
}

.content-wrapper {
    height: 100%;
    width: 100%;
    margin: auto;
}

.not-found-content {
    height: 95%;
    width: 100%;
    position: relative;
}

.header {
  text-align: center;
}

span {
  cursor: pointer;
  font-weight: bold;
  color: white;
}

.loginInputs {
  height: 95%;
  width: 100%;
  position: relative;
}

.header h1 {
    font-size: 30px;
}

.whiteCross {
    width: 35%;
    margin: 0 auto;
}

.whiteCross img {
    width: 100%;
}

@media (min-width: 599px) and (max-width: 968px) {
    section {
        height: 100%;
    }
}

@media (max-width: 599px) {
  .not-found-wrapper {
    width: 90%;
    height: 550px;
    padding: 10px 0px;
  }
}
@media (min-width: 599px) and (max-width: 960px) {
  .not-found-wrapper {
    width: 50%;
    height: 550px;
  }
}
@media (min-width: 960px) and (max-width: 1264px) {
  .not-found-wrapper {
    width: 40%;
    height: 550px;
  }
}
@media (min-width: 1264px) and (max-width: 1904px) {
  .not-found-wrapper {
    width: 30%;
    height: 550px;
  }
}
@media (min-width: 1904px) {
  .not-found-wrapper {
    width: 20%;
    height: 600px;
  }
}
</style>
